module.exports = __webpack_public_path__ + "static/img/02.335a692.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/tell_tex/02.jpg
// module id = 452
// module chunks = 1